import type { TimeEntry } from '@beacon/core';

import type { BeaconClient } from '../client.js';

export const timeEntriesApi = {
  /**
   * Update the `notes` field on a time entry.
   *
   * Server writes back to Harvest first; on Harvest failure the local
   * row is unchanged and the request rejects (502/503). On 503 the
   * UI should retry; on 502 it's a permanent error and we bubble.
   */
  updateNotes(
    client: BeaconClient,
    id: string,
    notes: string
  ): Promise<TimeEntry> {
    return client.patch<TimeEntry>(
      `/api/time-entries/${encodeURIComponent(id)}/notes`,
      { notes }
    );
  },
};
